import axios from 'axios';
import getHeaders from '../../constants/headers';
import { CONSUMER_BASE_URL, STORE_BASE_URL } from '../BaseURL';


export const postStoreCustomerAccount = (storeCustomerId, storeId, data) => {
    return axios({
      method: 'post',
      url:
        CONSUMER_BASE_URL +
        '/api/secure/v1/store/' +
        storeId +
        '/store-customer/' +
        storeCustomerId +
        '/store-customer-account', // for android use
      headers: getHeaders(),
      data: JSON.stringify(data),
    });
  };

  export const getStoreCustomerAccount =   (storeCustomerId, storeId) => {
    return axios({
      method: 'get',
      url:
        CONSUMER_BASE_URL +
        '/api/secure/v1/store/' +
        storeId +
        '/store-customer/' +
        storeCustomerId +
        '/store-customer-account', // for android use
      headers:   getHeaders(),
    });
  };

  export const getStoreCustomerBalance =   (storeCustomerId, storeId) => {
    return axios({
      method: 'get',
      url:
        STORE_BASE_URL +
        '/store/api/secure/v1/store/' +
        storeId +
        '/store-customer/' +
        storeCustomerId +
        '/balance', // for android use
      headers:   getHeaders(),
    });
  };
  

  
export const getStore = id => {
    return axios({
      method: 'get',
      url: STORE_BASE_URL + '/store/api/secure/v1/store/' + id,
      headers:   getHeaders(),
    });
  };
  

  export const storeCustomerGetInfo =   (storeCustomerId, storeId) => {
    return axios({
      method: 'get',
      url:
        CONSUMER_BASE_URL +
        '/api/secure/v1/store/' +
        storeId +
        '/store-customer/' +
        storeCustomerId,
      headers:   getHeaders(),
    });
  };

  // export const getCustomerOrders =   (storeCustomerId, storeId) => {
  //   return axios({
  //     method: 'get',
  //     url:
  //       STORE_BASE_URL +
  //       '/store/api/secure/v1/store/' +
  //       storeId +
  //       '/store-customer/' +
  //       storeCustomerId +
  //       '/order', // for android use
  //     headers:   getHeaders(),
  //   });
  // };

  export const getCustomerOrders =   (storeCustomerId, storeId, data) => {
    return axios({
      method: 'post',
      url:
        STORE_BASE_URL +
        '/store/api/secure/v1/store/' +
        storeId +
        '/store-customer/' +
        storeCustomerId +
        '/order-info', // for android use
      headers:   getHeaders(),
       data: JSON.stringify(data),
    });
  };
  export const getStoreCustomerOrderRevenue =   (storeCustomerId, storeId, data) => {
    return axios({
      method: 'post',
      url:
        STORE_BASE_URL +
        '/store/api/secure/v1/store/' +
        storeId +
        '/store-customer/' +
        storeCustomerId +
        '/order-revenue', // for android use
      headers:   getHeaders(),
       data: JSON.stringify(data),
    });
  };


  export const getStoreCustomerSource =  (storeId) => {
    return axios({
      method: 'get',
      url:
      CONSUMER_BASE_URL +
        '/api/secure/v1/store/' +
        storeId +
        '/customer-source',
      headers:   getHeaders(),
    });
  };

  export const checkCustomerCode = (storeId, data) => {
    return axios({
      method: 'post',
      url:
        CONSUMER_BASE_URL +
        '/api/secure/v1/store/' +
        storeId +
        '/store-customer/check-customer-code',
      headers: getHeaders(),
      data: JSON.stringify(data),
    });
  };

  export const StoreCustomerPendingOrderRevenue = (data) => {
    return axios({
      method: 'post',
      url:
        STORE_BASE_URL +
        '/store/api/secure/v1/store-customer-pending-order-revenue',
      headers: getHeaders(),
      data: JSON.stringify(data),
    });
  };

  export const StoreCustomerOrderRevenue = (data) => {
    return axios({
      method: 'post',
      url:
        STORE_BASE_URL +
        '/store/api/secure/v2/store-customer-order-revenue',
      headers: getHeaders(),
      data: JSON.stringify(data),
    });
  };


export const getCustomerOnlinePaymentList = async (data) => {
  return axios({
    method: "post",
    url:
      STORE_BASE_URL +
      "/store/api/secure/v1/customer-online-payment", // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateCustomerOnlinePayment = async (data) => {
  return axios({
    method: "put",
    url:
      STORE_BASE_URL +
      "/store/api/secure/v1/customer-online-payment", // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};